import emrService from '@/apis/emr/service';
import BaseSpin from '@/components/bases/BaseSpin';
import emrTypeHelper from '@/helper/emrType';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import { Segmented } from 'antd';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeathRecordTabList from './HeathRecordTabList';
import HealthRecordChart from './HealthRecordChart';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import WrapRefresh from '../components/WrapRefresh';

const PHRMobileRecordsByType = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { emrTypeCode, uid } = location?.state;
  const emrTypes = useGlobalMobileConfigs((s) => s.emrTypes);
  const emrType = emrTypes?.[emrTypeCode];
  const tabs = useMemo(() => {
    const tabs = [
      {
        label: <span className="cms-h5">{emrType?.name ?? 'Danh sách'}</span>,
        value: 'list',
        key: 'list',
      },
    ];
    if (emrType?.extra?.mobile?.type === 'listAndChart') {
      tabs.push({
        label: <span className="cms-h5">Thống kê</span>,
        value: 'chart',
        key: 'chart',
      });
    }
    return tabs;
  }, [emrType?.name, emrType?.extra?.mobile?.type]);

  const [tab, setTab] = React.useState<string>(tabs[0].value || '');

  const { data, isFetchingNextPage, fetchNextPage, refetch } = emrService.useGetEmrInfinite({
    uid,
    type: emrTypeCode,
    limit: 10,
    // start: rangeDate.startTime?.toDate(),
    // end: rangeDate.endTime?.toDate(),
  });

  const rawData = useMemo(
    () =>
      (data?.pages || []).reduce((d: IEMRData[], e) => {
        if (e?.data) d = [...d, ...e?.data];
        return d;
      }, []),
    [data?.pages],
  );

  const dataSource = useMemo(() => {
    try {
      const data_ = rawData?.map((d: any) => emrTypeHelper.transformData({ ...d.data, date: d.date })) || [];
      return (emrType?.extra.formDetail.convertData ? emrType.extra.formDetail.convertData(data_) : data_).reverse();
    } catch (error) {
      return [];
    }
  }, [rawData, emrType?.extra.formDetail]);

  return (
    <WrapRefresh onRefresh={refetch} containerStyle={{ top: 50 }}>
      <div className="overflow-hidden h-full bg-gray-2">
        {emrType?.extra?.mobile?.type === 'listAndChart' ? (
          <div className="pr-6 pl-6 py-2">
            <Segmented
              options={tabs}
              block
              value={tab}
              size="large"
              onChange={(value) => {
                setTab(value);
              }}
            />
          </div>
        ) : (
          <></>
        )}
        {tab === 'list' && (
          <HeathRecordTabList rawData={rawData} isFetchingNextPage={isFetchingNextPage} fetchNextPage={fetchNextPage} />
        )}

        {tab === 'list' && (
          <div className="absolute z-10 left-0 right-0 bottom-0 bg-white pt-4 pb-4 justify-center flex border-t-2 border-t-gray-4">
            <button
              onClick={() =>
                navigate(`/phr-mobile/logs/${uid}`, { state: { uid: uid, emrType: emrTypeCode, title: emrType?.name } })
              }
              className="flex flex-row h-9 w-40 bg-gradient-1 rounded-full justify-center items-center text-white "
            >
              <BaseIconSvg src="/icons/Regular/Plus - icon.svg" />
              <span className="pl-1 cms-h5">Thêm chỉ số</span>
            </button>
          </div>
        )}

        {tab === 'chart' && <HealthRecordChart emrType={emrType} data={dataSource} />}

        {isFetchingNextPage && (
          <div className="absolute z-20 top-0 left-0 bottom-0 right-0 flex flex-1 bg-gray-1 bg-opacity-80 justify-center items-center">
            <BaseSpin />
          </div>
        )}
      </div>
    </WrapRefresh>
  );
};

export default PHRMobileRecordsByType;
